import { theme } from 'antd';
import { TeamIcon } from 'assets/images/svg';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectTeamsByPersonID } from 'reduxStore/teams/selectors';
import { Loader } from 'zComponents/atoms';
import TeamDrawer from 'zComponents/molecules/TeamDrawer';
import { Empty, Flex, Tag } from 'zui/Antd';

const TeamsPanelContent = ({ personID }) => {
	const {
		token: { fontWeightStrong, paddingSM, paddingXXS }
	} = theme.useToken();

	// ✅ Redux state
	const teams = useSelector((state) => selectTeamsByPersonID(state, personID));

	const { loadingAddMembersTeam, deleteTeamMemberLoading } = useSelector((state) => state.Teams);

	// States
	const [openTeamDrawer, setOpenTeamDrawer] = useState(false);
	const [selectedTeam, setSelectedTeam] = useState(null);

	// Early returns for loading and empty states
	if (loadingAddMembersTeam || deleteTeamMemberLoading) {
		return (
			<Flex justify='center' style={{ width: '100%' }}>
				<Loader />
			</Flex>
		);
	}

	if (teams.length === 0) {
		return <Empty description='No teams' image={Empty.PRESENTED_IMAGE_SIMPLE} />;
	}

	return (
		<>
			<Flex wrap gap={paddingSM}>
				{teams.map((team) => (
					<Tag
						key={team.teamID}
						color='cyan'
						style={{
							fontWeight: fontWeightStrong,
							borderColor: 'currentColor',
							cursor: 'pointer',
							marginInlineEnd: 0
						}}
						onClick={() => {
							setSelectedTeam(team.teamID);
							setOpenTeamDrawer(true);
						}}
					>
						<Flex align='center' gap={paddingXXS}>
							<TeamIcon color='currentColor' />
							{team.name}
						</Flex>
					</Tag>
				))}
			</Flex>
			<TeamDrawer teamID={selectedTeam} visible={openTeamDrawer} setVisible={setOpenTeamDrawer} />
		</>
	);
};

export default TeamsPanelContent;
